Namespace 'Profiling.Dashboard'

class Profiling.Dashboard.ResultRowActions extends Backbone.View
  template: JST['backbone/templates/profiling/sessions/results_actions']

  initialize: ({model}) ->
    @model = notNull(model)

  render: ->
    @$el.html(@template(
      ticketCount: @model.tickets_count()
      contentCount: @model.contents_count()
    ))
    @
